import React from "react";
import "../ui/ui.scss";

const AVATAR_COLORS = [
  "#e11d48", "#ec4899", "#d946ef", "#a855f7", "#8b5cf6", "#6366f1",
  "#3b82f6", "#0ea5e9", "#06b6d4", "#14b8a6", "#10b981", "#22c55e",
  "#84cc16", "#eab308", "#f59e0b", "#f97316",
];

function getInitials(name = "") {
  return name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
}

function getColorIndex(name = "") {
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
  return ((hash % AVATAR_COLORS.length) + AVATAR_COLORS.length) % AVATAR_COLORS.length;
}

/**
 * UserAvatar — Deterministic colored initials avatar.
 *
 * Props:
 *   name      — Full name (used for initials + color)
 *   src       — Optional image URL (overrides initials)
 *   size      — sm | md | lg | xl
 *   bordered  — Show border + shadow
 *   className — Extra class
 */
const UserAvatar = ({ name = "", src, size = "md", bordered = false, className = "" }) => {
  if (src) {
    return (
      <img
        src={src}
        alt={name}
        className={`ui-avatar ui-avatar--${size} ${bordered ? "ui-avatar--bordered" : ""} ${className}`}
      />
    );
  }

  const idx = getColorIndex(name) + 1; // 1-indexed for SCSS
  return (
    <div
      className={`ui-avatar ui-avatar--${size} ui-avatar--color-${idx} ${bordered ? "ui-avatar--bordered" : ""} ${className}`}
    >
      {getInitials(name)}
    </div>
  );
};

export default UserAvatar;
